import type { Post } from "@/shared/lib/types"

export function getPostCover(post: Pick<Post, "media">): string | null {
	const media = post.media ?? []
	const preview = media.find((m) => m.type === "preview") ?? media.find((m) => m.type === "photo")
	if (preview) return preview.url
	return media.find((m) => m.thumbnailUrl)?.thumbnailUrl ?? null
}
